@if (formGroup$ | async; as formGroup) {
  <form [formGroup]="formGroup">
    <div class="container">
      <div class="row">
        <div class="col">
          <pas-input
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('sparePartNumber'))"
            formControlName="sparePartNumber"
            subLabel="{{ 'recourseCriteria.sparePartNumber' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('supplierNumber'))"
            formControlName="supplierNumber"
            subLabel="{{ 'recourseCriteria.supplierNumber' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-input
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('dealerNumber'))"
            formControlName="dealerNumber"
            subLabel="{{ 'recourseCriteria.dealerNumber' | translate }}"></pas-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-input
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('warrantyDays'))"
            formControlName="warrantyDays"
            subLabel="{{ 'recourseCriteria.warrantyDays' | translate }}"></pas-input>
        </div>
        <div class="col">
          <pas-select
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('warrantyCalculationMethod'))"
            [options]="warrantyCalculationMethodOptions"
            [showEmptyOption]="false"
            subLabel="{{ 'recourseCriteria.warrantyCalculationMethod' | translate }}"
            formControlName="warrantyCalculationMethod"></pas-select>
        </div>
        <div class="col">
          <pas-input
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('mileage'))"
            formControlName="mileage"
            subLabel="{{ 'recourseCriteria.mileage' | translate }}"></pas-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-select
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('isRecourseRelevant'))"
            [options]="recoursePossibleOptions"
            [showEmptyOption]="false"
            subLabel="{{ 'recourseCriteria.recourseRelevant' | translate }}"
            formControlName="isRecourseRelevant"></pas-select>
        </div>
        <div class="col">
          <pas-select
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('objectCriteriaGroup'))"
            [options]="objectCriteriaOptions"
            [showEmptyOption]="false"
            subLabel="{{ 'recourseCriteria.objectCriteriaGroup' | translate }}"
            formControlName="objectCriteriaGroup"></pas-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-textarea
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('comment'))"
            [cols]="3"
            [maxLength]="280"
            formControlName="comment"
            subLabel="{{ 'recourseCriteria.comment' | translate }}"></pas-textarea>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <pas-datetime-picker
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('validFrom'))"
            [minDate]="tomorrow"
            [maxDate]="longTimeAhead"
            locale="de"
            subLabel="{{ 'recourseCriteria.validFrom' | translate }}"
            formControlName="validFrom"
            pickerType="date"></pas-datetime-picker>
        </div>
        <div class="col">
          <pas-datetime-picker
            [validationMessages]="validationMessages"
            [formControl]="$any(formGroup.get('validTo'))"
            [minDate]="tomorrow"
            [maxDate]="longTimeAhead"
            locale="de"
            subLabel="{{ 'recourseCriteria.validTo' | translate }}"
            formControlName="validTo"
            pickerType="date"></pas-datetime-picker>
        </div>
      </div>
    </div>
  </form>
}
